import { RadioGroup, Field, Radio, Label } from '@headlessui/react';
import classNames from 'classnames';
import { RadioOption } from '@employ-engage/data';
import ErrorMessage from '../error-message/error-message';

export interface EERadioGroupProps {
  value?: any;
  onChange?: (val: any) => void;
  options?: RadioOption[] | null;
  mapOptionToLabel?: (option: RadioOption) => any;
  errors?: any;
  touched?: boolean;
  isColumn?: boolean;
  previewOnly?: boolean;
}

export function EERadioGroup({
  value,
  onChange,
  options,
  mapOptionToLabel,
  errors,
  touched,
  isColumn = false,
  previewOnly,
}: EERadioGroupProps) {
  return (
    <>
      <RadioGroup value={value} onChange={onChange}>
        <div
          className={classNames(`flex gap-2 flex-col`, {
            'sm:flex-col': isColumn,
            'sm:flex-row': !isColumn,
          })}
        >
          {options?.map((option) => {
            const label = mapOptionToLabel?.(option);
            return (
              <Field
                key={JSON.stringify(option.label)}
                disabled={previewOnly}
                className="flex gap-2 items-center"
              >
                <Radio
                  value={option.id}
                  className="flex justify-center items-center focus:outline-none focus:ring-0 focus:ring-offset-0 focus:ring-offset-transparent"
                >
                  {({ checked }) => (
                    <div className="rounded-full w-5 h-5 border-2 border-light-primary bg-light-primary flex justify-center items-center">
                      {checked && (
                        <div className="rounded-full w-2 h-2 bg-white" />
                      )}
                    </div>
                  )}
                </Radio>
                <Label>
                  <span>{label ? label : option.label}</span>
                </Label>
              </Field>
            );
          })}
        </div>
      </RadioGroup>
      <ErrorMessage errors={errors} touched={touched} />
    </>
  );
}

export default EERadioGroup;
